import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import styles, { buttonTheme } from './styles'

const Button = ({ onClick, children, theme = 'primary' }) => (
  <button type="button" onClick={onClick} className={cx(styles.button, buttonTheme(theme))} role="menuitem">
    {children}
  </button>
)

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
}

export default Button
